// extracted by mini-css-extract-plugin
export const main_footer = "Footer-module--main_footer--25-Rm";
export const main_footer_wrapper = "Footer-module--main_footer_wrapper--3MP7p";
export const sitename = "Footer-module--sitename--nsg05";
export const main_footer__menu = "Footer-module--main_footer__menu--2kFWl";